import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import {
	TEmKeycloakUsersRequest,
	TKeycloakGroupsRequest,
	TKeycloakUsersRequest,
	TEmKeycloakUserRequestBody,
	TCreateKeycloakUserRequestBody,
	TResetKeycloakUserPasswordRequest,
	TConnectedEmerchantsRequest,
} from 'redux/reducers/accessManagement/types';
import { TAccessManagementApi } from './types';

export const accessManagement: TAccessManagementApi = {
	getConnectedEmerchants: (payload: TConnectedEmerchantsRequest) =>
		http
			.get(endpoint.accessManagement.CONNECTED_EMERCHANTS, { params: payload })
			.then((response) => response.data),
	getEmKeycloakUsers: (payload: TEmKeycloakUsersRequest) =>
		http
			.post(endpoint.accessManagement.GET_EM_KEYCLOAK_USERS(payload.emId), {
				pageSize: payload.pageSize,
				pageNumber: payload.pageNumber,
			})
			.then((response) => response.data),
	getKeycloakGroups: (payload: TKeycloakGroupsRequest) =>
		http
			.post(endpoint.accessManagement.GET_KEYCLOAK_GROUPS, payload)
			.then((response) => response.data),
	getKeycloakUsers: (payload: TKeycloakUsersRequest) =>
		http
			.post(endpoint.accessManagement.GET_KEYCLOAK_USERS, payload)
			.then((response) => response.data),

	attachEmUser: (payload: TEmKeycloakUserRequestBody) =>
		http.post(endpoint.accessManagement.ATTACH_KEYCLOAK_USER, payload).then(() => {}),
	detachEmUser: (payload: TEmKeycloakUserRequestBody) =>
		http.post(endpoint.accessManagement.DETACH_KEYCLOAK_USER, payload).then(() => {}),
	createUser: (payload: TCreateKeycloakUserRequestBody) =>
		http.post(endpoint.accessManagement.CREATE_KEYCLOAK_USER, payload).then(() => {}),
	setUserEnabled: (payload: TEmKeycloakUserRequestBody) =>
		http.put(endpoint.accessManagement.SET_KEYCLOAK_USER_ENABLED, payload).then(() => {}),
	resetUserPassword: (payload: TResetKeycloakUserPasswordRequest) =>
		http.post(endpoint.accessManagement.RESET_KEYCLOAK_USER_PASSWORD, payload).then(() => {}),
};
